/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    SET_SELECTED_EMAIL_EMBED, LOADING_EMAILS,
    DOWNLOADING_EMAILS, CLEAR_SELECTED_EMAIL_STATE
} from 'state/actions/emailCollectionState/selected_embed_email_status';
// utils
import { log } from '@insticator/insticator-ui'; // iui-utils



/* ========== ~~~~~~~~~~ CONTENT EMAIL STATUS : REDUCER ~~~~~~~~~~ ========== */

const defaultState = {
    selectedEmbed: null,
    selectedEmbedName: '',
    loading: false,
    downloading: false
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components
const selectedEmbedEmailStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case SET_SELECTED_EMAIL_EMBED:
            newState.selectedEmbed = action.embedUUID;
            newState.selectedEmbedName = action.embedName;
            return newState;
        case LOADING_EMAILS:
            newState.loading = action.status;
            return newState;
        case DOWNLOADING_EMAILS:
            newState.downloading = action.status;
            return newState;
        case CLEAR_SELECTED_EMAIL_STATE:
            return defaultState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default selectedEmbedEmailStatus;